import React from 'react'
import { LinkToSwitch, StyledSwitchAccounts } from './SwitchAccounts.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRightArrowLeft } from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { StyledText } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const SwitchAccounts = ({ isHidden }: { isHidden: boolean }) => {
  const { t } = useTranslation('pricing')
  const navigate = useNavigate()

  const handleSwitchAccounts = () => {
    navigate('/account-selector', { replace: true })
  }

  return (
    <StyledSwitchAccounts isHidden={isHidden}>
      <LinkToSwitch onClick={handleSwitchAccounts}>
        <FontAwesomeIcon icon={faArrowRightArrowLeft as IconProp} />
        <StyledText>{t('switch_account')}</StyledText>
      </LinkToSwitch>
    </StyledSwitchAccounts>
  )
}
